import RouterViewGenerico from "../views/RouterViewGenerico.vue";
import rutasMasters from "../Aplicaciones/Masters/rutas";
import VueRouter from "vue-router";

const routes = [
  {
    path: "/",
    component: RouterViewGenerico,
    children: rutasMasters
  }
];

const router = new VueRouter({
  routes,
  mode: "history",
  base: process.env.BASE_URL
});

export default router;
